import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const React = require("react");
import Slider from "react-slick";
import { setCustomArrowsFocus } from "../../../utils/ui";
import { ResponsivePicture } from "../../Image";
import { Link } from "../../Link";
import { pushCollectionAction, titleAndAuthor } from "../CollectionUtils";
export const CollectionItemSlider = (param)=>{
    let { className = "bookslider", children } = param;
    return /*#__PURE__*/ _jsx(Slider, {
        accessibility: true,
        dots: true,
        arrows: true,
        infinite: false,
        variableWidth: true,
        className: className,
        dotsClass: "bookslider-dots",
        speed: 500,
        swipeToSlide: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 819,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 649,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 499,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ],
        onReInit: ()=>{
            const slides = document.querySelectorAll('.slick-slide');
            slides.forEach((slide)=>{
                slide.setAttribute('aria-hidden', 'false');
            });
            setCustomArrowsFocus();
            const dots = document.querySelectorAll('.bookslider-dots li');
            if (dots == null || dots.length == 0) {
                return;
            }
            dots.forEach((dot, key)=>{
                if (dot.classList.contains('slick-active')) {
                    dot.setAttribute('aria-current', 'true');
                } else {
                    dot.removeAttribute('aria-current');
                }
            });
        },
        slickPrev: ()=>{
            setCustomArrowsFocus();
        },
        slickNext: ()=>{
            setCustomArrowsFocus();
        },
        customPaging: (i)=>/*#__PURE__*/ _jsxs("button", {
                tabIndex: -1,
                children: [
                    /*#__PURE__*/ _jsxs("span", {
                        className: "sr-txt",
                        children: [
                            "Navigeer naar pagina ",
                            i + 1,
                            " van carousel"
                        ]
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        "aria-hidden": "true",
                        children: i + 1
                    })
                ]
            }),
        children: children
    });
};
export const CollectionItemSlide = (param)=>{
    let { item, route, push = ()=>pushCollectionAction()("Klik op boek in slider", titleAndAuthor(item)) } = param;
    const { Id, image } = item;
    const url = `${route}/${Id}`;
    return /*#__PURE__*/ _jsx("div", {
        className: `bookslider-item`,
        children: /*#__PURE__*/ _jsx(Link, {
            className: "bookcover bookcover--large",
            url: url,
            title: titleAndAuthor(item),
            handle: push,
            children: /*#__PURE__*/ _jsx("div", {
                className: "bookcover__inner",
                children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                    alt: image.AltText,
                    className: "bookcover__image",
                    defaultImageUrl: image.Teaser,
                    cropsPerMedia: [
                        {
                            crops: [
                                {
                                    url: image.Teaser,
                                    width: 110
                                },
                                {
                                    url: image.Teaser2x,
                                    width: 220
                                }
                            ]
                        }
                    ],
                    width: 200,
                    height: 307
                })
            })
        })
    });
};
